<template>
    <Authenticated>
        <div class="text-4xl mt-4 mb-4">Биржа {{exchange.name}}</div>
        <Card>
            <template #title>
                Pairs
            </template>
            <template #content>

                <div class="mb-4 flex flex-row">
                    Доступных пар: {{countPairs}} . Активных пар: {{countActivePairs}} (по ним собираются данные свечей и на них возможно создание ботов)
                </div>

                <div class="mb-4 flex flex-row w-14rem">
                    <SpinnerWrapper :loading="processSetActive"><Button @click="setActive()" label="Save active state" /></SpinnerWrapper>
                </div>

                <DataTable :value="statePairs">
                    <Column header="Active">
                        <template #body="slotProps">
                            <input type="checkbox" v-model="slotProps.data.is_active" />
                        </template>
                    </Column>
                    <Column>
                        <template #body="slotProps">
                            <div class="flex flex-row align-items-center">
                                <div class="flex align-items-center justify-content-center full-rounded" style="width:2.5rem;height:2.5rem">
                                    <img :src="slotProps.data.logo" style="width:2.5rem;height:2.5rem" class="full-rounded" :alt="slotProps.data.ccxt_symbol"/>
                                </div>
                                <div class="flex flex-column">
                                    <div class="text-xl ml-4">
                                        <Link :href="'/exchanges/pair/'+slotProps.data.id" class="link">{{slotProps.data.ccxt_symbol}}</Link>
                                    </div>
                                    <div class="ml-2 text-gray-500">
                                        #{{slotProps.data.id}}
                                        <Link :href="'/exchanges/pair/'+slotProps.data.id" class="ml-2 text-gray-500">график</Link>
                                        <a href target="_blank" :href="slotProps.data.tradingview_url" class="ml-2 text-gray-500">tradingview</a>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </Column>
                    <Column header="Volume 24h" >
                        <template #body="slotProps">
                            <div class="text-base text-gray-700" v-html="slotProps.data.volume + 'k'"></div>
                        </template>
                    </Column>
                    <Column header="Change 24h" >
                        <template #body="slotProps">
                            <div class="text-base" v-html="round_colored(slotProps.data.price_change, 3)"></div>
                        </template>
                    </Column>
                    <Column header="Width 24h" >
                        <template #body="slotProps">
                            <div class="text-base text-gray-700" v-html="slotProps.data.price_minmax"></div>
                        </template>
                    </Column>
                    <Column v-for="timestamp in timestamps" :header="timestamp+' gap P75'" :key="timestamp">
                        <template #body="slotProps">
                            <div class="text-base" v-if="slotProps.data.gaps[timestamp].missing === 0">{{slotProps.data.gaps[timestamp].percentile}}s</div>
                            <div v-else>-</div>
                        </template>
                    </Column>
                </DataTable>


            </template>
        </Card>
    </Authenticated>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Checkbox from 'primevue/checkbox';
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import SpinnerWrapper from "@/Components/SpinnerWrapper.vue";
import helperMethods from '@/helpers'
import { router, Link } from "@inertiajs/vue2";

export default {
    components: {SpinnerWrapper, Authenticated, Card, Button, DataTable, Column, Checkbox, ColumnGroup, Row, Link},
    props: {
        exchange: Object,
        pairs: Array,
        countPairs: Number,
        countActivePairs: Number,
    },
    data(){
        return {
            statePairs: this.pairs,
            filters: {
                minVolume: null
            },
            processSetActive: false,
            timestamps: ["1m", "3m", "5m", "15m", "30m", "1h", "4h"]
        }
    },
    mounted(){
        this.statePairs = this.pairs
    },
    computed: {
        filteredPairs(){
            return this.statePairs.filter(pair => {
                if(this.filters.minVolume){
                    return pair.volume >= this.filters.minVolume
                }
                return true
            })
        },
        activePairs(){
            return this.statePairs.filter(pair => pair.is_active)
        }
    },
    methods: {
        setActive(){
            router.post("/exchanges/set_active_pairs", {
                    exchange_id: this.exchange.id,
                    pair_ids: this.activePairs.map(pair => pair.id)
                },{
                    onStart: () => this.processSetActive = true,
                    onFinish: () => this.processSetActive = false,
                });
        },
        ... helperMethods,
    }
}
</script>
